export default [
    {
        index: 1,
        date: 'March 18, 2019',
        author: {
            name: 'Todd Mansur',
            title: 'Captain/ Marine Naturalist'
        },
        school: 'San Juan Elementary',
        students: 58,
        departure: '10:00 am',
        weather: 'calm',
        log: ['As the students departed Dana Point Harbor they immediately had marine mammal sightings with several Sea Lions swimming in the harbor.','At 10:10 the students had their first Whale sighting.','A small juvenile Gray whale in 40 feet of water heading north and was very shy of boats and hard to see. Our decision was to look for others.','At 10:22 we spotted another North bound Gray whale. It was 3miles North West of Dana point in 150 feet of water. The whale showed on the surface every 4minutes and took several breaths.','At 10:41 we noticed a small pod of Common Dolphins and decided to Leave the Gray whale and follow. It was a pod of approximately 30 Common Dolphin that played well with the boat.','At 10:58 we spotted two more North bound Gray whales that were about to join up with two more very close by. This was now a pod of four whales just off Dana Point.','At 11:15 we spotted more Common Dolphin near the whales feeding.','At 11:30 We spotted Two more North bound Gray whales in 90 feet of water off Dana Point.','As we watched a small pod of Whiteside Dolphins Showed up swimming down the coast so we followed them back to the harbor.','At 11:53 we entered the harbor and saw three inshore Bottlenose Dolphins.'],
        sightings:[
            '8 Gray whales','60 Common Dolphins','10 Whiteside Dolphins','3 Bottlenose Dolphins'
        ]
    },
    {
        index: 2,
        date: 'March 19, 2019',
        author: {
            name: 'Todd Mansur',
            title: 'Captain/ Marine Naturalist'
        },
        school: 'Laguna Niguel Elementary',
        students: 90,
        departure: '10:00 am',
        weather: 'Cloudy with 5 knots of SE wind',
        log: ['Weather Cloudy with 5 knots of SE wind','At 10:19 we spotted an amazing pod of 6 North bound Gray Whales.','They were heading North in 180 feet of water 2 miles off Dana Point and taking several breaths showing their tail flukes every 3 minutes.','The Whales put on such a great show that we stayed with them for almost 45 minutes.','At 11:05 we left to search for other mammals.','At 11:20 we spotted a pod of approximately 500 Common Dolphins.','They where feeding in 600 feet of water 3 miles off Dana Point.','At 11:36 we headed back'],
        sightings:[
            '6 Gray Whales','500 Common Dolphins'
        ]
    },
    {
        index: 3,
        date: 'March 20, 2019',
        author: {
            name: 'Todd Mansur',
            title: 'Captain/ Marine Naturalist'
        },
        school: 'San Juan Elementary',
        students: 72,
        departure: '10:00 am',
        weather: 'rain and clouds with light winds',
        log: ['Weather rain and clouds with light winds','At 10:05 right outside the harbor we spotted a juvenile Gray Whale heading north.','The Whale was in 40 feet of water and stayed down for 10 minutes before coming up to breathe.','Thinking we would find others at 10:25 we left.','At 10:35 we spotted a pod of Common Dolphins feeding in 60 feet of water 2 miles south of Dana Point. We saw approximately 50 Dolphins in the pod. They played well with the boat.','At 10:55 we left to search for other mammals.','At 11:25 we finally spotted another Gray Whale. This whale was heading South late for the time of year. The whale showed its tail flukes before diving unfortunately we we’re only able to see it a couple of times and had to start heading home.'],
        sightings:[
            '2 Gray whales','50 Common Dolphins'
        ]
    },
    {
        index: 4,
        date: 'March 27, 2019',
        author: {
            name: 'Todd Mansur',
            title: 'Captain/ Marine Naturalist'
        },
        school: 'Del Obispo Elementary',
        students: 72,
        departure: '9:30 am',
        weather: 'Cloudy / Calm',
        log: ['At 9:50 we spotted a small pod of Common Dolphins feeding off Dana Point spread out to Salt','Creek. They we’re feeding but took time to play with the boat approximately 100 Commons.','At 10:15 we left to search for other mammals.','At 10:30 we briefly stopped at the Dana Point Navigation buoy to look at Sea Lions hauled out warming themselves up. We didn’t stay long as we spotted a whale spout 1 mile up the coast from us.','At 10:50 we caught up with 2 north bound Gray whales in 150 feet of water. The Whales shoed great taking breaths every 5 minutes and showing their large tail flukes before diving','At 11:30 we headed home.'],
        sightings:[
            '2 Gray whales','100 Common Dolphins'
        ]
    },
    {
        index: 5,
        date: 'April 8, 2019',
        author: {
            name: 'Todd Mansur',
            title: 'Captain/ Marine Naturalist'
        },
        school: 'Marion Bergeson Elementary',
        students: 104,
        departure: '10:05 am',
        weather: 'calm with clouds',
        log: ['At 10:15 we stopped 1 mile off Dana point at the navigation buoy to look at Sea Lions hauls out warming up.','As we looked at Sea Lions we saw splashes off in the distance. Knowing they would be Dolphins we headed out.','At 10:30 we we’re following approximately 150 Common Dolphins 2 miles off Dana Point.','They we’re feeding and playing giving the students a great show.','At 10:45 a boat called us on the radio and said they had seen a spout near us.','It turned out to be an 85-foot Blue Whale the first sighted in 2019 off Dana Point.','What an exciting show as it came up to breath then show us its enormous tail flukes.','At 11:45 we had to head home.'],
        sightings:[
            '1 Blue Whale','150 common Dolphin'
        ]
    },
    {
        index: 6,
        date: 'April 11,2019',
        author: {
            name: 'Todd Mansur',
            title: 'Captain/ Marine Naturalist'
        },
        school: 'Concordia Elementary',
        students: 90,
        departure: '10:00 am',
        weather: 'calm party sunny',
        log: ['As we left the harbor the students we’re enjoying the Sea Lions that we’re swimming next to the bait dock.','As we headed out there we’re boats talking on the radio about Dolphins 3 miles out so we headed that way.','At 10:20 we had joined up with approximately 200 Common Dolphins. We watched as they chased down fish to eat and played with the boat. At 10:50 we left to search for other mammals.','It took almost the entire trip to find a Gray whale. We actually spotted our only Gray whale just as we we’re heading into the harbor.','It was in 36 feet of water and we we’re able to get a coulee quick looks before heading in but it’s was to unpredictable to get photos of.'],
        sightings:[
            '1 Gray Whale','200 Common Dolphins'
        ]
    },
    {
        index: 7,
        date: 'April 19, 2019',
        author: {
            name: 'Todd Mansur',
            title: 'Captain/ Marine Naturalist'
        },
        school: 'Kinoshita Elementary',
        students: 107,
        departure: '10:00 am',
        weather: '7 knots of SE wind and clouds',
        log: ['As we headed out we decided to head to a close navigation buoy where we knew there would be Sea Lions hauled out warming themselves.','At 10:15 we headed south hoping to find Whales or Dolphins. There had been no reports that day so we hoped to get lucky.','It seemed like we were never going to find any mammals when suddenly at 11:10 we spotted a pod of common dolphins 5 miles South of Dana Point harbor. Approximately 100 Common Dolphins traveling up the coast in 600 feet of water. they played with the boat and put on a great show. However this would be our only sighting at 11:30 we had to head back.'],
        sightings:[
            '100 Common Dolphins'
        ]
    },
    {
        index: 8,
        date: 'April 22, 2019',
        author: {
            name: 'Todd Mansur',
            title: 'Captain/ Marine Naturalist'
        },
        school: 'Marion Bergeson Elementary',
        students: 118,
        departure: '9:45 am',
        weather: 'calm and sunny',
        log: ['As we headed out we decided to just go south. There hadn’t been many Whales sighted in the past few days so we we’re hoping to at least find Dolphins.','At 9:55 we sighted a pod of Common Dolphin approximately 100 in 60 feet of water feeding and playing with the boat.','At 10:10 we spotted a small pod of Whiteside Dolphins approximately 15 feeding close to the commons we we’re following so we headed over to take a look.','At 10:30 we spotted a very small northbound juvenile Gray Whale. It was so hard to see as it barely broke the surface to breath. Knowing the students wouldn’t be able to see it we left in search of other mammals.','At 11:00 one of the teachers asked if we could go in.'],
        sightings:[
            '1 Gray whale','100 Common Dolphins','15 White sided Dolphin'
        ]
    },
    {
        index: 9,
        date: 'April 24, 2019',
        author: {
            name: 'Todd Mansur',
            title: 'Captain/ Marine Naturalist'
        },
        school: 'Estancia Elementary',
        students: 75,
        departure: '10:00 am',
        weather: 'calm sunny',
        log: ['At 10:15 arrive at Dana Point navigation buoy to look at Sea Lions hauled out on the buoy warming themselves.','As we left the Sea Lions we got a call on the radio from another boat that they had a pod of Common Dolphins about 3 miles out. With high hopes of also finding a whale we headed out towards the dolphins.','At 10:35 we found the pod of approximately 200 Common Dolphins feeding and playing with the boat. Hoping to find a whale at 11:00 we left the dolphins in search.','At 11:30 with no luck finding a whale we had to head back.'],
        sightings:[
            '200 Common Dolphins'
        ]
    },
    {
        index: 10,
        date: 'May 24, 2019',
        author: {
            name: 'Todd Mansur',
            title: 'Captain/ Marine Naturalist'
        },
        school: 'Ambuehl Elementary',
        students: 88,
        departure: '10:00 am',
        weather: 'calm and sunny',
        log: ['As we Headed out we already heard talk on the ships radio that there were dolphins about 6 miles out. This meant we had to drive strait there in order to be able to have time with them.','At 10:30 we we’re among over 1000 Common Dolphins a huge pod a super pod. As we watched and followed this amazing pod of Dolphins they we’re very playful with the boat constantly swimming under the bow of the boat as we moved along.','At 11:05 while still following the dolphins we thought we saw a whale come up. We looked in the area for over 20 minutes. Assuming it was a Minke whale a very small baleen whale that sometimes eludes boats we headed off back to the harbor.'],
        sightings:[
            '1000 Common Dolphins','1 Minke Whale'
        ]
    }
]